import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ProductSummaryComponent from "./product-summary.component";
import { useHistory, useLocation } from "react-router-dom";
import {AccessRights} from "lib/constants/accessRights";
import LoadingComponent from "components/loading";
import qs from "query-string";
import { getLang } from "app/feature/constants";
import { INVENTORY_LIST_PAGE } from "modules/stockflow/config/stockflow.route";
import {canAccess} from "../../../../profile/redux/selector/profile.selector";

function ProductSummaryContainer( {activeSummaryIndex} ) {
  const hasStockflowViewAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.TrackcoPortal.BRANCH_INVENTORY) ||
    canAccess(state, AccessRights.TrackcoPortal.DEALER_INVENTORY) ||
    canAccess(state, AccessRights.TrackcoPortal.BRANCH_SUMMARY) ||
    canAccess(state, AccessRights.TrackcoPortal.DEALER_SUMMARY)
  );
  const hasStockflowBranchInventoryAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.TrackcoPortal.BRANCH_INVENTORY));

  const hasStockflowDealerInventoryAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.TrackcoPortal.DEALER_INVENTORY));

  const hasStockflowBranchSummaryAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.TrackcoPortal.BRANCH_SUMMARY));

  const hasStockflowDealerSummaryAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.TrackcoPortal.DEALER_SUMMARY));

  const lang = useSelector(state => state.constant.languages);
  const history = useHistory();
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(activeSummaryIndex);

  const qsParams = qs.parse(location.search);
  const currentSearch = qsParams.summary || "";

  useEffect(() => {
    if (!hasStockflowViewAccessRight) {
      history.push("/admin/dashboard");
    }
  }, [history, hasStockflowViewAccessRight]);

  let tabLabels = [];
  tabLabels.push({
    label: getLang(lang, "label.BRANCH_INVENTORY"),
    access: hasStockflowBranchInventoryAccessRight,
  });
  tabLabels.push({
    label: getLang(lang, "label.DEALER_INVENTORY"),
    access: hasStockflowDealerInventoryAccessRight,
  });
  tabLabels.push({
    label: getLang(lang, "label.SUM_BY_BRANCH"),
    access: hasStockflowBranchSummaryAccessRight,
  });
  tabLabels.push({
    label: getLang(lang, "label.SUM_BY_DEALER"),
    access: hasStockflowDealerSummaryAccessRight,
  });

  useEffect(() => {
    let tempIndex = 0;
    switch (currentSearch) {
      case "to-branch":
        tempIndex = 0;
        break;
      case "to-dealer":
        tempIndex = 1;
        break;
      case "by-branch":
        tempIndex = 2;
        break;
      case "by-dealer":
        tempIndex = 3;
        break;
      default:
        tempIndex = 0;
    }
    setActiveIndex(tempIndex);
  }, [currentSearch]);

  if (!hasStockflowViewAccessRight) return <LoadingComponent />;

  const handleChange = (event, index) => {
    setActiveIndex(index);
    history.replace({
      pathname: INVENTORY_LIST_PAGE,
      search: `?type=product&summary=${
        index === 0
          ? "to-branch"
          : index === 1
            ? "to-dealer"
            : index === 2
              ? "by-branch"
              : "by-dealer"
      }`,
    });

  };

  return (
    <>
      <ProductSummaryComponent
        handleChange={handleChange}
        activeIndex={activeIndex}
        tabLabels={tabLabels}
        lang={lang}
      />
    </>
  );
}

export default ProductSummaryContainer;
